var e, r;
function i() {
  return r || (r = 1, e = function(n) {
    return n === void 0;
  }), e;
}
export {
  i as __require
};
